import React from 'react';

import TableAntd from '../../../Components/TableAntd/TableAntd';

export default function DenyTaskReasonList() {
  // Options for type filter
  const typeOptions = [
    { text: 'Agendamento', value: 'Scheduling' },
    { text: 'Centro de Treinamento', value: 'CT' },
    { text: 'Logística', value: 'Logistics' },
    { text: 'Instrutor', value: 'Instructor' },
    { text: 'Motorista', value: 'Driver' },
  ];

  const columns = (getColumnSearchProps) => {
    const columns = [
      {
        dataIndex: 'name',
        title: 'Nome',
        ...getColumnSearchProps('name', 'Nome'),
        sorter: (a, b) => a.name?.localeCompare(b.name),
        sortDirections: ['descend', 'ascend'],
      },
      {
        dataIndex: 'type',
        title: 'Tipo',
        filters: typeOptions,
        filterSearch: true,
        onFilter: (value, record) => record.type === value,
        render: (text) => {
          switch (text) {
            case 'Scheduling':
              return 'Agendamento';
            case 'CT':
              return 'Centro de Treinamento';
            case 'Logistics':
              return 'Logística';
            case 'Instructor':
              return 'Instrutor';
            case 'Driver':
              return 'Motorista';
            default:
              return text;
          }
        },
        sorter: (a, b) => a.type?.localeCompare(b.type),
        sortDirections: ['descend', 'ascend'],
      },
    ];
    return columns;
  };

  return (
    <TableAntd
      columnsTable={(getColumnSearchProps) => columns(getColumnSearchProps)}
      routePermissions="DenyTaskReason"
      toggleStatusRoute="DenyTaskReason"
      requestName="DenyTaskReason?filters[0].Field=Type&filters[0].Condition=NOT_IN&filters[0].Value=NoBilling"
      route="/MotivoDescarte"
      cdPage="id"
      btnNew={true}
    />
  );
}
